import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { auth } from '../firebase/firebaseConfig';
import { signOut } from 'firebase/auth';
import { getRenewalReturnPath } from '../utils/billingReturn';
import { hasAccountAccess } from '../utils/subscriptionAccess';

export default function GuestRoute() {
    const { currentUser, userLoading } = useAuth();
    const { search } = useLocation();
    const pending = ['printShop','supplier','specialist'].includes(currentUser?.type) && currentUser.status !== 'approved';
    useEffect(() => {
        if (!userLoading && pending) signOut(auth).catch(error => console.error('Could not end pending listing session',error));
    }, [userLoading,pending]);
    // Preserve the login component across Auth transitions so status messages and form data survive.
    if (userLoading || pending) return <Outlet />;
    if (!hasAccountAccess(currentUser)) return <Outlet />;
    const billingReturn = getRenewalReturnPath(search);
    if (billingReturn && ['printShop','supplier','specialist'].includes(currentUser?.type)) return <Navigate to={billingReturn} replace />;
    if (currentUser?.type === 'printShop') return <Navigate to="/shop/dashboard" replace />;
    if (['supplier','specialist'].includes(currentUser?.type)) return <Navigate to="/supplier/dashboard" replace />;
    if (currentUser?.type === 'admin') return <Navigate to="/admin/dashboard" replace />;
    return <Outlet />;
}
